'use client';

import { usePathname } from 'next/navigation';

import { usePermission } from '@/lib/contexts/PermissionContext';
import { clearSessionAndRedirect } from '@/lib/utils/session';

// 公開LP・法務ページ(未ログイン向けマーケティング画面)ではデモバナーを出さない
const PUBLIC_PATHS = ['/', '/terms', '/privacy', '/legal'];

/**
 * デモ環境で常時表示する注意バナー。
 * 所属組織がデモ(isDemo)のときのみ表示し、本登録への導線を提示する。
 */
export function DemoBanner() {
  const { isDemo } = usePermission();
  const pathname = usePathname();

  if (!isDemo) return null;

  const isPublicPage = PUBLIC_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
  if (isPublicPage) return null;

  // 本登録へ。デモCookieが残っていると middleware が /signup → /projects に弾くため、
  // 先にデモセッションを破棄してからフル遷移する。
  const handleStartFree = () => {
    void clearSessionAndRedirect('/signup');
  };

  return (
    <div className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-blue-900 px-4 py-2 text-center text-sm text-white">
      <span>
        これはデモ環境です。データは定期的にリセットされます。不特定多数が利用するため、機密情報・実データは登録しないでください。
      </span>
      <button
        type="button"
        onClick={handleStartFree}
        className="font-semibold underline underline-offset-2 hover:text-blue-100"
      >
        無料で始める
      </button>
    </div>
  );
}
